/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */

import Utils from '../../../utils/utils';

class Insert {
  static execute(target: string, index: string | number, payload: any, pageReference: string) {
    const displayPropertPayload: { [key: string]: any } = {};
    // nonFormProperties holds displayProperty if it is sent thorugh payload
    // Ex- Multiselect sends display property so that it can be maintained in redux along with unique key
    if (Object.hasOwn(payload, 'nonFormProperties')) {
      payload.nonFormProperties.forEach((displayProperty: string) => {
        displayPropertPayload[displayProperty] = payload[displayProperty];
        delete payload[displayProperty];
      });
      delete payload.nonFormProperties;
    }
    const actionPayload = {
      instruction: typeof index === 'string' ? 'ADD' : 'INSERT',
      content: {
        ...Utils.unflatten(payload)
      }
    };
    const formSubmitContent = JSON.parse(JSON.stringify(actionPayload)); // cloning the JSON
    delete formSubmitContent.content.classID;
    const instruction = {
      target: Utils.buildInstructionPageReference(pageReference, target),
      content: { ...formSubmitContent.content },
      [typeof index === 'string' ? 'groupIndex' : 'listIndex']: index,
      instruction: typeof index === 'string' ? 'ADD' : 'INSERT'
    };

    return {
      instruction,
      actionPayload,
      displayPropertPayload
    };
  }
}
export default Insert;
